export default __webpack_public_path__ + "static/media/Fair.eb627a0e.svg";